module.exports = __webpack_public_path__ + "static/media/restart.102a4979.png";